var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.525 1050.253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.568,88.872c6-9.124,11.1-21.24,7.106-31.763-2.12-5.582-7.041-10.374-6.77-16.94.287-6.9,5.621-11.276,10.808-13.167,4.212-1.527,8.524-.854,12.816-1.766,6.584-1.4,12.576-4.42,19.36-5.048C57.477,19.3,67.1,20.7,76.634,22.2c14.4,3.177,48.941,7.927,71.878,1.515,6.471-3.289,13.516-5.62,20.54-4.775a21.129,21.129,0,0,1,17.033,12.79c2.854,7.024,1.823,15.274.582,22.911-1.748,10.751-3.846,21.6-8.34,31.214s-11.722,17.964-20.787,20.827c-16.9,0-22.613,8.257-56.741,14.732s-34.128-10.61-74.117-6.475a21.008,21.008,0,0,1-20.993-4.135c-3.237-2.821-5.965-7.136-5.629-11.83C.34,95.139,2.558,91.931,4.568,88.872Z",
    transform: "translate(0 -0.087)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.275,123.495a13.961,13.961,0,0,0,6.673,5.647,13.89,13.89,0,0,0-1.066-8.662,13.966,13.966,0,0,0-6.673-5.648A13.893,13.893,0,0,0,16.275,123.495Z",
    transform: "translate(-0.072 11.211)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.716,122.222a13.932,13.932,0,0,1,5.345,6.912,14.015,14.015,0,0,1-8.628-1.47,13.932,13.932,0,0,1-5.345-6.912A14.015,14.015,0,0,1,17.716,122.222Z",
    transform: "translate(-0.044 11.183)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.57,6.933H80.5v.344H104.57Z",
    transform: "translate(8.151 -0.03)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.119,7.191h-.344v3.172h.344Z",
    transform: "translate(8.467 -0.031)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.578,7.191h-.344v3.172h.344Z",
    transform: "translate(7.554 -0.031)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.839,23.472H92.764v.344h24.074Z",
    transform: "translate(9.393 -0.11)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.675,20.371h-.344v3.172h.344Z",
    transform: "translate(8.602 -0.095)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.215,20.371h-.344v3.172h.344Z",
    transform: "translate(9.515 -0.095)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.979,31.224H124.9v.344h24.075Z",
    transform: "translate(15.183 2.642)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.814,28.123h-.343v3.172h.343Z",
    transform: "translate(11.386 2.43)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.355,28.123h-.344v3.172h.344Z",
    transform: "translate(15.1 2.43)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.559,111.162H122.485v.343h24.074Z",
    transform: "translate(12.404 11.229)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,108.061h-.344v3.172h.344Z",
    transform: "translate(11.177 11.244)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.935,108.061h-.343v3.172h.343Z",
    transform: "translate(15.112 11.244)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.261,55.86H81.187V56.2h24.074Z",
    transform: "translate(8.221 4.778)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1,52.759h-.344v3.172H88.1Z",
    transform: "translate(7.599 4.617)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.637,52.759h-.344v3.172h.344Z",
    transform: "translate(8.512 4.617)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.864,97.38H88.79v.344h24.074Z",
    transform: "translate(8.991 8.377)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7,94.279h-.344V97.45H95.7Z",
    transform: "translate(8.258 8.302)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.24,94.279H105.9V97.45h.344Z",
    transform: "translate(9.171 8.302)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.571,84.8H127.5v.344h24.075Z",
    transform: "translate(15.17 7.287)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.406,81.7h-.344v3.172h.344Z",
    transform: "translate(11.611 7.186)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.947,81.7H144.6v3.172h.344Z",
    transform: "translate(15.087 7.186)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.451,121.63H30.734v-.293H71.158V107.172h-37l-1.8-3.733.264-.126,1.718,3.568h37.11Z",
    transform: "translate(3.523 11.267)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.165,128.879a3.067,3.067,0,1,0-3.076-3.067A3.072,3.072,0,0,0,36.165,128.879Z",
    transform: "translate(2.969 11.173)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.631,128.879a3.067,3.067,0,1,0-3.076-3.067A3.072,3.072,0,0,0,66.631,128.879Z",
    transform: "translate(5.706 11.173)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.549,62.271a1.9,1.9,0,1,0-1.9-1.9A1.9,1.9,0,0,0,102.549,62.271Z",
    transform: "translate(8.905 5.151)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.755,102.192H29.988l-9.9-32.272H85.953l-.06.19ZM30.2,101.9H75.54L85.554,70.212H20.481Z",
    transform: "translate(-0.097 8.104)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,100.521H32L23.3,71.9H81.156l-.053.169Z",
    transform: "translate(-0.113 8.018)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,66.987l-.283-.075,1.933-7.264H99.991v.292H88.972Z",
    transform: "translate(8.159 5.418)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.677,79.751H23.3v.286H82.677Z",
    transform: "translate(-0.113 6.846)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.293,90.563H26.619v.286H79.293Z",
    transform: "translate(3.369 7.783)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.325,70.066h-.293v31.98h.293Z",
    transform: "translate(4.59 8.095)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.495,70.057l-2.1,31.979.292.019,2.1-31.979Z",
    transform: "translate(5.647 8.096)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.857,70.057l-.292.019,2.091,31.98.292-.019Z",
    transform: "translate(3.468 8.096)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.951,129.1H9.087v.343H178.951Z",
    transform: "translate(-0.044 11.142)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.972,11.4s2.514,7.133.967,8.231,5.221,10.06,5.221,10.06l8.121-2.195L121.834,20s-.58-7.5-.58-8.6S111.972,11.4,111.972,11.4Z",
    transform: "translate(10.604 -0.049)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.972,11.4s2.514,7.133.967,8.231,5.221,10.06,5.221,10.06l8.121-2.195L121.834,20s-.58-7.5-.58-8.6S111.972,11.4,111.972,11.4Z",
    transform: "translate(10.604 -0.049)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.731,62.475s-.734,9.145,0,13.9S109.565,94.3,109.565,94.3s0,24.875,4.036,25.24,6.971.731,7.337-.731-1.834-2.2-.733-2.927,1.468-3.292,0-6.219,0-32.556,0-32.556l6.971,18.656s.733,15.364,1.468,17.558-.734,6.219,1.834,6.585,5.5-1.829,6.971-2.561-2.2-.732-1.467-1.1,2.935-1.463,2.2-1.829-1.468-17.924-1.468-17.924S134.7,59,132.129,57.536a3.154,3.154,0,0,0-4.219,1.057Z",
    transform: "translate(11.43 11.492)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.362,118.374V121.3s-3.3,7.955,0,7.955,5.87.825,5.87-.273v-9.877Z",
    transform: "translate(10.215 11.194)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.093,118.369v2.926s3.3,7.955,0,7.955-5.87.824-5.87-.273V119.1Z",
    transform: "translate(11.784 11.194)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.1,16.672a6.584,6.584,0,1,0-6.6-6.584A6.594,6.594,0,0,0,117.1,16.672Z",
    transform: "translate(10.388 -0.013)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,22.434s1.834,5.487,4.77,4.39l2.935-1.1,5.137,35.117s-4.035,5.853-9.906,2.195S115.1,22.434,115.1,22.434Z",
    transform: "translate(10.778 2.833)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.268,21.314l1.651-3.475s9.723,4.573,11.19,6.036a5.7,5.7,0,0,1,1.468,3.658l-2.568,9.145s.733,20.119.733,20.851,2.568,4.755.734,3.292-2.2-2.926-3.669-.732a26.884,26.884,0,0,1-4.77,4.755Z",
    transform: "translate(11.389 -0.083)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.141,47.8l-1.1,10.242s-6.6,5.853-5.137,6.219a2.031,2.031,0,0,0,2.2-1.1s2.568,2.561,4.036,1.1,5.137-15.364,5.137-15.364Z",
    transform: "translate(11.784 4.72)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.238.769a7.365,7.365,0,0,0-4.265.709A6.249,6.249,0,0,0,111.5,2.916c-1.2,1.515-2.241,3.422-1.794,5.3l.518-.2a3.373,3.373,0,0,1-.327,1.451c.073-.212.317.131.252.345l-.571,1.869a1.766,1.766,0,0,1,2.251,1.339c.065-2.171.291-4.66,2.057-5.931a7.132,7.132,0,0,1,3.1-1.01,6.258,6.258,0,0,1,3.007.015,2.158,2.158,0,0,1,1.557,2.292,1.025,1.025,0,0,1,1.154.567,2.969,2.969,0,0,1,.236,1.364c.472.332,1.007-.327,1.2-.869a7.835,7.835,0,0,0,.609-3.956,3.022,3.022,0,0,0-2.682-2.6.934.934,0,0,0,.244-.66L121.2,2.137a1.232,1.232,0,0,0,.736-.387C121.485,2.241,117.963.795,117.238.769Z",
    transform: "translate(10.442 0)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.877,20.215s-2.987-2.918-4.062-2.739-2.543,2.739-2.543,2.739-8.805,2.926-8.439,5.853,4.4,17.193,4.4,17.193,3.3,17.193.366,19.022,13.943,6.584,14.309,4.39,1.1-24.143,0-27.435S116.877,20.215,116.877,20.215Z",
    transform: "translate(9.999 -0.081)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.854,26.11h4.537s3.168,13.9,3.535,15.364,1.1,8.413.734,8.413-7.705-1.463-7.705-.366Z",
    transform: "translate(11.869 2.72)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.609,60.59H112.241a48.264,48.264,0,0,1,0-22.459h17.368A30.14,30.14,0,0,0,129.609,60.59Z",
    transform: "translate(10.819 3.957)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.151,51.09l5.137,2.195s9.907,1.463,9.907-2.561-9.907-1.829-9.907-1.829l-3.3-1.053Z",
    transform: "translate(10.006 4.271)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.219,23.9l-4.4,1.1-3.3,19.387s-1.1,5.121.734,5.487,6.972,3.292,6.972,3.292.733-5.487,2.2-5.487l-3.669-2.926,2.2-12.8Z",
    transform: "translate(9.052 2.627)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.572,61.545H19.5v.344H43.572Z",
    transform: "translate(-0.094 5.271)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.408,58.444h-.344v3.172h.344Z",
    transform: "translate(-0.126 5.121)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.949,58.444H36.6v3.172h.344Z",
    transform: "translate(3.168 5.121)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.04,10.551H27.965v.344H52.04Z",
    transform: "translate(2.829 -0.048)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.589,10.809h-.344v3.172h.344Z",
    transform: "translate(3.917 -0.049)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.049,10.809H34.7v3.172h.344Z",
    transform: "translate(3.004 -0.049)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4,44.49H52.33v.344H76.4Z",
    transform: "translate(5.297 3.792)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.953,44.748h-.344V47.92h.344Z",
    transform: "translate(6.027 3.906)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.413,44.748h-.344V47.92h.344Z",
    transform: "translate(5.114 3.906)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.278,44.317H11.2v.344H35.278Z",
    transform: "translate(-0.054 3.777)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.827,44.576h-.344v3.172h.344Z",
    transform: "translate(-0.138 3.89)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.287,44.576h-.344v3.172h.344Z",
    transform: "translate(-0.087 3.89)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.308,27.09H40.234v.344H64.308Z",
    transform: "translate(4.072 2.284)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.144,23.988H46.8V27.16h.344Z",
    transform: "translate(4.051 2.063)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.685,23.988h-.344V27.16h.344Z",
    transform: "translate(4.965 2.063)",
    fill: "#f2f2f2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.1d75193179d1492b934cc0cf50b60990.svg";
export { ForwardRef as ReactComponent };